import * as actions from './sourcesActions'
import { Record, Map, List } from 'immutable'

export const SourceRecord = Record({
  id: null,
  name: null,
  link: null,
  hasPaywall: false,
}, 'source')

const initialState = Map({
  loading: false,
  timestamp: null,
  failedToLoad: false,
  sources: List(),
})

function sources(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_SOURCES:
      return state
        .set('loading', true)
        .set('failedToLoad', false)

    case actions.FETCH_SOURCES_SUCCESS:
      return state
        .set('loading', false)
        .set('timestamp', action.timestamp)
        .set('sources', List(
          action.response.data.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1 }
            if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1 }
            return 0
          }).map(source => {
            const { id, name, link, hasPaywall } = source
            return SourceRecord({ id, name, link, hasPaywall })
          })
        ))

    case actions.FETCH_SOURCES_FAILURE:
      return state
        .set('loading', false)
        .set('failedToLoad', true)
        .set('timestamp', null)
        .set('sources', List())

    default:
      return state
  }
}

export default sources
